import entityAnnotationMarkers from './markers';

const stripEntityAnnotationMarkers = (content: string): string =>
	content
		.replace(
			new RegExp(
				`${entityAnnotationMarkers.start}start:[^${entityAnnotationMarkers.end}]*${entityAnnotationMarkers.end}`,
				'g',
			),
			'',
		)
		.replace(new RegExp(entityAnnotationMarkers.endMarker, 'g'), '');

export default stripEntityAnnotationMarkers;
